import { Box, Paper } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import ExcessiveAlarmSitesTable from '@sophocles/views/sites/components/ExcessiveAlarmSitesTable';

function ExcessiveAlarmSitesView(props) {
  const { t } = useTranslation();
  return (
    <AppNav page={`admin_excessive-sites`} notFullHeight={true} {...props}>
      <Box sx={{ top: '64px', mx: 2, pb: '24px' }}>
        <TitleBar showBackButton title={t('sites.excessiveSiteAlarms', 'Excessive Site Alarms')} />
        <Paper sx={{ mx: 1 }}>
          <ExcessiveAlarmSitesTable />
        </Paper>
      </Box>
    </AppNav>
  );
}

export default ExcessiveAlarmSitesView;
